import { render, staticRenderFns } from "./phone-form.vue?vue&type=template&id=54a125b3&scoped=true"
import script from "./phone-form.vue?vue&type=script&lang=js"
export * from "./phone-form.vue?vue&type=script&lang=js"
import style0 from "./phone-form.vue?vue&type=style&index=0&id=54a125b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a125b3",
  null
  
)

export default component.exports